var React = require('react');

function Stripes06Inline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#3A495C","d":"M319,0L28.9,290.1h13L331.9,0H319z","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M309.3,60.4L2.5,367.1h13L322.2,60.4L309.3,60.4L309.3,60.4z","key":1})]);
}

Stripes06Inline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 333.3 367.1"};

module.exports = Stripes06Inline;

Stripes06Inline.default = Stripes06Inline;
